export type ListSettingsType = {
  current_page: number;
  total_pages: number;
  total_elements: number;
  total: number;
};

export const getListSettings = (payload: ListSettingsType) => {
  return {
    // eslint-disable-next-line @typescript-eslint/camelcase
    current_page: payload.current_page,
    /*TODO: No funciona bien el endpoint para el filtro per_page
    per_page: payload.per_page,*/
    // eslint-disable-next-line @typescript-eslint/camelcase
    total_pages: payload.total_pages,
    // eslint-disable-next-line @typescript-eslint/camelcase
    total_elements: payload.total_elements,
    total: payload.total
  };
};

export const INITIAL_LIST_SETTINGS = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  current_page: 1,
  // eslint-disable-next-line @typescript-eslint/camelcase
  total_pages: 1,
  // eslint-disable-next-line @typescript-eslint/camelcase
  total_elements: 1,
  total: 0
};
